module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fade"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "width": "400"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "elevation-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_vm._v("            \n              Change Avatar\n            ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "card vue-avatar-cropper-demo text-center"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('img', {
    staticClass: "card-img avatar",
    attrs: {
      "src": _vm.currentAvatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-img-overlay"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "id": "pick-avatar"
    }
  }, [_vm._v("\n                    Select a new photo\n                  ")])])]), _vm._v(" "), _c('avatar-cropper', {
    attrs: {
      "trigger": "#pick-avatar",
      "upload-form-name": "avatar",
      "upload-form-data": _vm.formData,
      "upload-headers": _vm.uploadHeaders,
      "upload-url": _vm.uploadUrl,
      "labels": _vm.labels
    },
    on: {
      "uploading": _vm.handleUploading,
      "uploaded": _vm.handleUploaded,
      "completed": _vm.handleCompleted,
      "error": _vm.handlerError
    }
  })], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "vld-parent"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9dd8259c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChangeAvatarModal.vue
// module id = 2247
// module chunks = 0